import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ced7dfc4"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" You can also change a region's position and other properties (e.g., size) by selecting it in the Navigator panel and editing in the Styles panel. ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        cancelBtnTxt: "Cancel",
        actionBtnTxt: "Move",
        onOnPopupDone: _ctx.onPopupDone,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRegionsTitles, (title) => {
                    return (_openBlock(), _createElementBlock("li", { key: title }, _toDisplayString(title), 1));
                }), 128))
            ]),
            _createVNode(_component_Alert, { type: "info" }, {
                default: _withCtx(() => [
                    _hoisted_1
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnPopupDone", "onOnUserArgChanged"]));
}
